import { addDoc, collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase';

const cleanPayload = (payload = {}) => Object.fromEntries(
  Object.entries(payload).filter(([, value]) => value !== undefined)
);

export const appendAuditEvent = async ({ eventId, game, type, payload = {}, idempotencyKey = '' }) => {
  if (!eventId || !type) return null;

  const user = getAuth().currentUser;
  try {
    const auditCollection = collection(db, 'bingoMachineEvents', eventId, 'auditEvents');
    const record = {
        type,
        eventId,
        gameId: game?.id || null,
        gameNumber: Number(game?.gameNumber) || null,
        gameName: game?.name || null,
        patternId: game?.pattern || null,
        prizeAmount: game?.prizeAmount ?? null,
        payload: cleanPayload(payload),
        actorUid: user?.uid || null,
        actorEmail: user?.email || null,
        timestamp: serverTimestamp(),
      };

    if (idempotencyKey) {
      const safeId = idempotencyKey.replace(/[^a-zA-Z0-9_-]/g, '-').slice(0, 240);
      await setDoc(doc(auditCollection, safeId), record);
      return safeId;
    }

    return await addDoc(auditCollection, record);
  } catch (error) {
    // Audit failure must not interrupt live bingo operations.
    // eslint-disable-next-line no-console
    console.error(`Unable to append ${type} audit event:`, error);
    return null;
  }
};

export const formatAuditBall = (ball) => {
  if (!ball) return '';
  if (typeof ball === 'string') return ball;
  return `${ball.letter || ''}${ball.number || ''}`;
};
